
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'EnterBaihai',
  setup () {
    return {}
  }
})
